module.exports = __webpack_public_path__ + "static/media/moreTlcPrimary.9f4d727c.svg";